import CompanyPhoneNumber from 'src/models/CompanyPhoneNumber/CompanyPhoneNumber';
import createCollectionResource from 'src/actions/shared/createResource';

export default createCollectionResource<CompanyPhoneNumber>({
  name: 'companyPhoneNumbers',
  endpoint: 'v1/orgs/:orgId/company-phone-numbers',
  observerCreator: ({ actions }) => {
    return ({ dispatch }) => {
      return {
        onAddSuccess(item) {
          if (item) {
            dispatch(actions.broadcast(item));
          }
        },
      };
    };
  },
});
